import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | expired | error

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      return;
    }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(() => setStatus('success'))
      .catch(err => {
        if (err.response?.status === 400) {
          const detail = err.response.data?.detail || '';
          setStatus(detail.includes('expiré') ? 'expired' : 'error');
        } else {
          setStatus('error');
        }
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#0f0e17] flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="font-heading font-black text-3xl text-white mb-8 tracking-tight">
          K<span style={{ color: '#ff6b6b' }}>u</span>rso
        </div>

        <div className={`kurso-card p-8 ${status === 'success' ? 'border-[#20c997]/30' : status === 'loading' ? '' : 'border-[#ff6b6b]/30'}`}
          data-testid="verify-email-card">

          {status === 'loading' && (
            <>
              <Loader2 size={36} className="text-[#ff6b6b] animate-spin mx-auto mb-4" />
              <p className="text-[#a0a0ab]">Vérification de votre email…</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-16 h-16 rounded-full bg-[#20c997]/10 flex items-center justify-center mx-auto mb-5">
                <CheckCircle size={32} className="text-[#20c997]" />
              </div>
              <h2 className="text-white font-bold text-2xl mb-2">Email vérifié !</h2>
              <p className="text-[#a0a0ab] text-sm mb-7">
                Votre adresse email est confirmée. Vous pouvez maintenant générer des cours IA sur Kurso.
              </p>
              <button
                onClick={() => navigate('/dashboard')}
                className="btn-primary w-full text-sm font-semibold"
                data-testid="go-dashboard-btn"
              >
                Aller au tableau de bord →
              </button>
            </>
          )}

          {(status === 'expired' || status === 'error') && (
            <>
              <div className="w-16 h-16 rounded-full bg-[#ff6b6b]/10 flex items-center justify-center mx-auto mb-5">
                <AlertCircle size={32} className="text-[#ff6b6b]" />
              </div>
              <h2 className="text-white font-bold text-2xl mb-2">
                {status === 'expired' ? 'Lien expiré' : 'Lien invalide'}
              </h2>
              <p className="text-[#a0a0ab] text-sm mb-7">
                {status === 'expired'
                  ? 'Ce lien a expiré (validité 24 h). Connectez-vous à votre tableau de bord pour en demander un nouveau.'
                  : 'Ce lien est invalide ou a déjà été utilisé.'}
              </p>
              <button
                onClick={() => navigate('/dashboard')}
                className="btn-primary w-full text-sm font-semibold"
                data-testid="go-dashboard-btn-error"
              >
                Retour au tableau de bord
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
